// 手机号验证
export function validatePhone(phone) {
  const phoneReg = /^1\d{10}$/
  return phoneReg.test(phone)
}

// 验证身份证
export function validateIdCard(idCard) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(idCard)
}
